import * as R from "ramda";
import { TEMPLATE_CLIENT as templateClient } from "../common";

const QUESTION_GROUPER = R.groupBy(question => question.category);
const SORT_QUESTIONS = R.sortBy(R.prop("number"));

export const ADD_CATEGORY = "ADD_CATEGORY";
export const ADD_QUESTION = "ADD_QUESTION";
export const RENAME_CATEGORY = "RENAME_CATEGORY";
export const SET_QUESTIONS = "SET_QUESTIONS";
export const SET_NAME = "SET_NAME";
export const REMOVE_CATEGORY = "REMOVE_CATEGORY";
export const SET_TEMPLATE_ID = "SET_TEMPLATE_ID";
export const CLEAR_REVISION = "CLEAR_REVISION";

export default {
  namespaced: true,
  state: {
    categories: {},
    name: "",
    templateId: "",
  },
  getters: {
    getTemplateId: state => state.templateId,
    getRevisionName: state => state.name,
    getCategories: state => state.categories,
    getQuestionsFromCategory: state => category =>
      SORT_QUESTIONS(state.categories[category]),
  },
  mutations: {
    [SET_NAME](state, { name }) {
      state.name = name;
    },
    [RENAME_CATEGORY](state, { oldName, newName }) {
      state.categories[newName] = state.categories[oldName];
      delete state.categories[oldName];
    },
    [REMOVE_CATEGORY](state, { name }) {
      delete state.categories[name];
    },
    [ADD_CATEGORY](state, { name }) {
      state.categories[name] = [];
    },
    [ADD_QUESTION](state, { name, question }) {
      if (name in state.categories) {
        state.categories[name].push(question);
      } else {
        state.categories[name] = [question];
      }
    },
    [SET_QUESTIONS](state, { name, questions }) {
      state.categories[name] = questions;
    },
    [SET_TEMPLATE_ID](state, { templateId }) {
      state.templateId = templateId;
    },
    [CLEAR_REVISION](state) {
      state.categories = {};
      state.name = "";
      state.templateId = "";
    },
  },
  actions: {
    setFromTemplate({ commit }, { template }) {
      commit(SET_NAME, { name: template.name });
      const categories = QUESTION_GROUPER(template.questions);
      for (const [category, questions] of Object.entries(categories)) {
        commit(SET_QUESTIONS, { name: category, questions });
      }
    },
    updateQuestions({ commit }, { name, questions }) {
      const reOrderedQuestions = questions.map((q, indx) => {
        return { ...q, number: indx + 1 };
      });
      commit(SET_QUESTIONS, { name, questions: reOrderedQuestions });
    },
    removeQuestion({ commit, getters }, { name, question }) {
      const questions = getters.getQuestionsFromCategory(name);
      const finalQuestions = questions.filter(q => q.name !== question.name);
      const reOrderedQuestions = finalQuestions.map((q, indx) => {
        return { ...q, number: indx + 1 };
      });
      commit(SET_QUESTIONS, { name, questions: reOrderedQuestions });
    },
    async createRevision({ commit, getters, rootGetters }) {
      const categories = getters.getCategories;

      // transform it to match API's format
      let questions = [];
      for (const [category, qs] of Object.entries(categories)) {
        questions = [
          ...questions,
          ...qs.map(q => {
            const description = q.description ? q.description : "";
            return { ...q, category, description };
          }),
        ];
      }

      const templateRevision = {
        name: getters.getRevisionName,
        questions,
        createdBy: rootGetters["auth/getUserEmail"],
      };

      const templateId = getters.getTemplateId;

      const jwtToken = rootGetters["auth/getIdentityToken"];
      const requestOpts = {
        headers: { Authorization: `Bearer ${jwtToken}` },
      };

      try {
        if (templateId) {
          await templateClient.put(
            `/${templateId}`,
            templateRevision,
            requestOpts
          );
        } else {
          await templateClient.post(
            `/`,
            templateRevision,
            requestOpts
          );
        }
      } catch (err) {
        /* ignore */
      }

      commit(CLEAR_REVISION);
    },
  },
};
